var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.366117 1.32956C0.854272 0.887541 1.64573 0.887541 2.13388 1.32956L7.5 6.18856L12.8661 1.32956C13.3543 0.887541 14.1457 0.887541 14.6339 1.32956C15.122 1.77159 15.122 2.48825 14.6339 2.93027L8.38388 8.58962C7.89573 9.03165 7.10427 9.03165 6.61612 8.58962L0.366117 2.93027C-0.122039 2.48825 -0.122039 1.77159 0.366117 1.32956Z",
    fill: "#36505E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.67ce14178f086f470a1aca8bb7946f8e.svg";
export { ForwardRef as ReactComponent };